const product = {
  product: "Produktas", // translated 
  products: "Produktai", // translated 
  information: "Informacija", // translated 
  additionalInformation: "Papildoma informacija", // translated 
  contactUs: "Susisiekite su mumis", // translated 
  contactUsText: "Norite pritaikyti savo kelionę ar turite kitų klausimų?", // translated 
  dropUsAnEmail: "Rašykite mums el", // translated 
  viewLess: "Žiūrėti mažiau", // translated 
  viewMore: "Peržiūrėti daugiau", // translated 
  less: "mažiau", // translated 
  more: "daugiau", // translated 
  highlights: "Pabrėžia", // translated 
  inclusions: "Inkliuzai", // translated 
  exclusions: "Išimtys", // translated 
  pleaseWait: "Prašau palauk...", // translated 
  tourType: "Ekskursijos tipas", // translated 
  search: "Paieška", // translated 
  available: "Yra", // translated 
  availableTours: "Galimos ekskursijos", // translated 
  sortBy: "RŪŠIUOTI PAGAL", // translated 
  priceLowToHigh: "Kaina: nuo mažos iki aukštos", // translated 
  priceHighToLow: "Kaina: nuo didelės iki mažos", // translated 
  mostPopular: "Populiariausias", // translated 
  roomOnly: "Tik kambarys", // translated 
  bedAndBreakfast: "Nakvynė ir pusryčiai", // translated 
  halfBoard: "Dalinis maitinimas", // translated 
  fullBoard: "Pilnas maitinimas", // translated 
  allInclusive: "Viskas įskaičiuota", // translated 
  viewDetails: "Išsamiau", // translated 
  close: "Uždaryti", // translated 
  at: "At", // At dat, // translated 
  person: "asmuo", // translated 
  cancellationPolicy: "Atšaukimo politika", // translated 
  cancellationIs: "atšaukimas yra", // translated 
  to: "Į", // translated 
  bookingRemarks: "Užsakymo pastabos", // translated 
  totalPrice: "Bendra kaina", // translated 
  back: "Atgal", // translated 
  bookNow: "Užsakyti dabar", // translated 
  minutes: "Minutės", // translated 
  visitDuration: "Apsilankymo trukmė", // translated 
  itinerary: "Maršrutas", // translated 
  airportToHotel: "Oro uosto į viešbutį", // translated 
  hotelToAirport: "Viešbutis iki oro uosto", // translated 
  details: "detales", // translated 
  servicesDetails: "Paslaugų informacija", // translated 
  services: "Paslaugos", // translated 
  day: "Diena", // translated 
  next: "Kitas", // translated 
  nextStep: "Kitas žingsnis", // translated 
  skip: "Praleisti", // translated 
  remarks: "Pastabos", // translated 
  optional: "neprivaloma", // translated 
  guests: "Svečiai", // translated 
  payment: "Mokėjimas", // translated 
  pickup: "paimti", // translated 
  featuredPackage: "Teminis paketas", // translated 
  flights: "Skrydžiai", // translated 
  accommodation: "Apgyvendinimas", // translated 
  transfers: "Pervedimai", // translated 
  tours: "Ekskursijos", // translated 
  experiences: "Patirtys", // translated 
  featuredTour: "Teminė ekskursija", // translated 
  From: "Nuo", // translated 
  Accommodation: "Apgyvendinimas", // translated 
  approxDuration: "apytiksliai trukmės", // translated 
  travellerInformation: "Informacija keliautojams", // translated 
  bookingOverview: "Užsakymo apžvalga", // translated 
  checkout: "Patikra", // translated 
  paymentFailed: "Mokėjimas nepavyko", // translated 
  paymentSuccess: "Mokėjimo sėkmė", // translated 
  night: "Naktis", // translated 
  nights: "Naktys", // translated 
  viewEscapes: "Žiūrėti Escape", // translated 
  viewExperience: "Peržiūrėkite patirtį", // translated 
  escapeType: "Pabėgimo tipas", // translated 
  adultsOnly: "Tik suaugusiems", // translated 
  totalDuration: "Bendra trukmė", // translated 
  options: "Galimybės", // translated 
  departingAirport: "Išvykimo oro uostas", // translated 
  childrenAreNotAllowedInThisTour: "Vaikai į šią ekskursiją neįleidžiami", // translated 
};



export default product;
